/** Platform catalog slugs hidden until a future release (empty or unfinished). */
export const DEFERRED_PLATFORM_SLUGS = new Set<string>(['certifications']);

export function isDeferredPlatformSlug(slug: string): boolean {
  return DEFERRED_PLATFORM_SLUGS.has(slug);
}
